import { createAction, createListenerMiddleware, } from '@reduxjs/toolkit'
import { Amplify } from "aws-amplify";
import { authenticationFlowTypeFeature } from '../../feature-flags';
import store, { RootState } from '../store';

// @ts-ignore
import awsconfig from "../../aws-exports";
import { feedback } from '../../components/Feedback/feedback';

export const initAmplify = createAction( 'amplify/init' );

const listenerMiddlewareAmplify = createListenerMiddleware()

// Parameters

listenerMiddlewareAmplify.startListening( {
  actionCreator: initAmplify,
  effect: async( action, listenerApi ) => {

    const amplifyConfig = {
      ...awsconfig,
      Auth: {
        // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'


        // For migration user_passwort_auth is required
        // authenticationFlowType: "USER_SRP_AUTH",
        authenticationFlowType: authenticationFlowTypeFeature,
      },
    };

    const store = listenerApi.getState() as RootState;
    const client_id = store.app.searchParameters.client_id;

    // We configure the Amplify Auth component in the context of using a client website client-id
    // if no clientId is found (direct login not from a client) the web client id of the broker will be used as default

    // In addition: This needs to be set for the USER_PASSWORD_AUTH flow
    // https://docs.amplify.aws/lib/auth/switch-auth/q/platform/js
    if( client_id ) {
      amplifyConfig.aws_user_pools_web_client_id = client_id;
    } else if( !client_id && authenticationFlowTypeFeature === 'USER_PASSWORD_AUTH' ) {
      if (import.meta.env.DEV ) {
        listenerApi.dispatch( feedback( { message: 'Caution: client_id is missing.' } ) );
      }
    }

    Amplify.configure(amplifyConfig);

  }
} )

export default listenerMiddlewareAmplify;
